import React from 'react';
import FeedbackComment from 'donor/portal/pages/FeedbackDashboard/Feedback/FeedbackComment';
import { ApolloClient, FetchResult } from 'apollo-boost';
import { FeedbackCommentBodyWithIndex, SelectedFeedback } from '../utils';
import { toUserType } from 'donor/portal/pages/FeedbackDashboard/Feedback/api';
import {
  FeedbackCommentProps,
  FeedbackSectionId,
  UserType,
} from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import { SuccessResponse } from '../../ReportsBeta/NewReport/api';

export interface RenderCommentsProps {
  reportId: number;
  isSectionCompleted: boolean;
  feedback: FeedbackCommentBodyWithIndex[];
  currentUserName: string;
  currentUserType: UserType;
  currentUserEmail: string | undefined;
  currentUserId: string | undefined;
  selectedSection: SelectedFeedback;
  programName: string;
  updateQuestionLevelComment: (
    client: ApolloClient<object>,
    commentId: number,
    comment: string,
    reportId: number,
    sectionId: FeedbackSectionId,
  ) => Promise<FetchResult<SuccessResponse<'updateComment'>>>;
  deleteQuestionLevelComment: (
    client: ApolloClient<object>,
    commentId: number,
    comment: string,
    reportId: number,
    sectionId: FeedbackSectionId,
  ) => Promise<FetchResult<SuccessResponse<'deleteComment'>>>;
  handleDeleteComment: (selected: SelectedFeedback, index: number) => unknown;
  handleUpdateComment: (
    selected: SelectedFeedback,
    index: number,
    comment: FeedbackCommentProps,
  ) => unknown;
}

const RenderComments: React.FC<RenderCommentsProps> = ({
  feedback,
  currentUserEmail,
  currentUserId,
  currentUserName,
  currentUserType,
  selectedSection,
  updateQuestionLevelComment,
  deleteQuestionLevelComment,
  handleDeleteComment,
  handleUpdateComment,
}) => {
  return (
    <>
      {feedback.map((c, i) => (
        <FeedbackComment
          key={c.commentId || i}
          index={c.index}
          comment={{
            commentId: c.commentId,
            createdAt: c.createdAt,
            name: c.userName,
            text: c.comment,
            accountType: toUserType(c.userType),
            details: c.details,
            email: c.userEmail,
            updatedAt: c.createdAt,
            userId: c.userId,
          }}
          reportId={c.reportId}
          sectionId={c.sectionId}
          currentUserName={currentUserName}
          currentUserType={currentUserType}
          currentUserEmail={currentUserEmail}
          currentUserId={currentUserId}
          handleDelete={deleteQuestionLevelComment}
          handleSave={updateQuestionLevelComment}
          onSuccessDelete={() => handleDeleteComment(selectedSection, i)}
          onSuccessSave={c => handleUpdateComment(selectedSection, i, c)}
        />
      ))}
    </>
  );
};

export default RenderComments;
